export const DEEP_ANALYSIS_PROVIDERS = ['all', 'booking', 'expedia'] as const;
export enum INSIGHT_CARD_VALUE {
    NA = 'na',
    NOCHANGES = 'nochanges',
}
